import MBookTimeSlotDialog from './MBookTimeSlotDialog.vue';

export { MBookTimeSlotDialog };
export default MBookTimeSlotDialog;
